import {
  IPayeeEngagement,
  IPayerEngagement,
  IPayerPayeePayeeOwnedData,
  IPayerPayeePayerOwnedData,
  PayeeTaxDocumentSharePermission,
  PayerPayeeStatus
} from "@wingspanhq/payments/dist/interfaces";
import {
  ISharedMember,
  ISharedUser
} from "@wingspanhq/users/dist/lib/interfaces";
import { ListRequestQuery } from "../../../utils/serviceHelper";
import { serviceSearch } from "../service";
import { PayerPayeeEngagementSearchableStatus } from "../types";

export interface ISearchablePayerPayeeEngagement {
  engagementId: IPayerEngagement["engagementId"];
  payerPayeeEngagementId: IPayerEngagement["payerPayeeEngagementId"];
  status: IPayerEngagement["status"];
  requirements: IPayerEngagement["requirements"];
  engagementName: IPayerEngagement["engagementName"];
  isDefault: IPayerEngagement["isDefault"];
  isWorkLoggingEnabled?: boolean | "true" | "false";
  createdAt: Date;
  collaboratorGroupIds?: IPayeeEngagement["collaboratorGroupIds"];
  payeeOwnedData?: IPayerEngagement["payeeOwnedData"];
  labels?: IPayerEngagement["labels"];
}

export interface IPayerRow {
  createdAt: Date;
  updatedAt: Date;
  payerId: string;

  // searchableStatus: PayerPayeeEngagementSearchableStatus;

  payeeOwnedData?: IPayerPayeePayeeOwnedData;
  payerOwnedData?: {
    status?: IPayerPayeePayerOwnedData["status"];
    autoPayStrategy?: IPayerPayeePayerOwnedData["autoPayStrategy"];
  };

  engagements: ISearchablePayerPayeeEngagement[];
  user: ISharedUser;
  member?: ISharedMember;
}

export type PayerRowsQueryFilter = {
  searchString?: string;
  searchableStatus?: PayerPayeeEngagementSearchableStatus;
  "payeeOwnedData.status"?:
    | PayerPayeeStatus
    | {
        in?: PayerPayeeStatus[];
      };
  "payeeOwnedData.shareTaxDocument"?:
    | PayeeTaxDocumentSharePermission
    | {
        in?: PayeeTaxDocumentSharePermission[];
      };
  "engagements.payerPayeeEngagementId"?: string;
  "engagements.requirements.requirementId"?: string;
  "engagements.isWorkLoggingEnabled"?: boolean;
  payerId?: string | { in?: string[] };
};

export type PayerRowsQuerySort = {
  updatedAt?: "asc" | "desc";
};

export type PayerRowsQuery = ListRequestQuery<
  PayerRowsQueryFilter,
  PayerRowsQuerySort
>;

export const getPayerRows = async (
  query?: PayerRowsQuery
): Promise<IPayerRow[]> => {
  const response = await serviceSearch.get("/payer-row", {
    params: query
  });

  return response.data;
};

export type IPayerSearchRowsSummary = {
  listSize: number;
};

export const getPayerRowsSummary = async (
  params?: PayerRowsQuery
): Promise<IPayerSearchRowsSummary> => {
  const { headers } = await serviceSearch.get(`/payer-row`, {
    params,
    headers: {
      "X-WS-Get-List-Summary": "true"
    }
  });

  return {
    listSize: Number(headers["x-ws-list-size"])
  };
};
